import moment from 'moment';

export const getMonthNameByIndex = (index: string) => {
    switch (index) {
        case '1':
            return 'Ianuarie';
        case '2':
            return 'Februarie';
        case '3':
            return 'Martie';
        case '4':
            return 'Aprilie';
        case '5':
            return 'Mai';
        case '6':
            return 'Iunie';
        case '7':
            return 'Iulie';
        case '8':
            return 'August';
        case '9':
            return 'Septembrie';
        case '10':
            return 'Octombrie';
        case '11':
            return 'Noiembrie';
        case '12':
            return 'Decembrie';
        case '01':
            return 'Ianuarie';
        case '02':
            return 'Februarie';
        case '03':
            return 'Martie';
        case '04':
            return 'Aprilie';
        case '05':
            return 'Mai';
        case '06':
            return 'Iunie';
        case '07':
            return 'Iulie';
        case '08':
            return 'August';
        case '09':
            return 'Septembrie';
        default:
            return 'Ianuarie';
    }
};

export const formatDateWithRomanianMonth = (date: any) => {
    const momentDate = new (moment as any)(date);

    const day = momentDate.format('D');
    const month = momentDate.format('M');
    const year = momentDate.format('YYYY');

    return `${day} ${getMonthNameByIndex(month)} ${year}`;
};

export const formatWithSlash = (date: any) => {
    return new (moment as any)(date).format('DD/MM/YYYY');
};

export const formatWithDot = (date: any) => {
    return new (moment as any)(date).format('DD.MM.YYYY');
};

export const generateArrayOfYears = (): number[] => {
    const min = 1920;
    const max = new Date().getFullYear();

    const years = [];

    for (let index = max; index >= min; index--) {
        years.push(index);
    }

    return years;
};

export const getAge = (dateString: string) => {
    const today = new Date();
    const birthDate = new Date(dateString);

    const m = today.getMonth() - birthDate.getMonth();
    let age = today.getFullYear() - birthDate.getFullYear();

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }

    return age;
};
